export const programMap = {
  BPU: 'Second Step® Bullying Prevention Unit Training',
  CPU: 'Second Step® Child Protection Unit Training',
  K5P: 'Second Step® K5 Digital Program',
  K8P: 'Second Step® K8 Digital Program',
  MSP: 'Second Step® K8 Digital Program',
  SSP: 'Second Step® K8 Digital Program',
  HSP: 'Second Step® High School Digital Program',
  SELA: 'Second Step® SEL for Adults Program',
}
